/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function FisicaQuantica() {
  return (
    <PaginasEspecificas posicao="6" endereco="/fisica" materia="Física" />
  );
}

export default FisicaQuantica;
